import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "element-header" }
const _hoisted_4 = { class: "element-box" }
const _hoisted_5 = { class: "form-header mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive overflow-auto pt-4"
}
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { style: {"min-width":"130px!important","text-align":"center"} }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import partnerPracticesService from '@/api/AddressBook/partnerPractices';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import {downloadFile, getSortIconClass} from '@/shared/functions';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {computed, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import Search from '../Search.vue';
import {IAddressBookFilters, IAddressBookList} from "@/interfaces/AddressBook/IAddressBook";
import ExcelExportButton from "@/components/ExcelExportButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const partnerPractices = ref<IAddressBookList>();
const federalStatesDropdown = ref([]);
const partnerId = ref<number | null>(null);
const showModal = ref(false);
const isSearching = ref(false);
const isLoaded = ref(false);
const isExcelLoaded = ref(false);

const filters = ref<IAddressBookFilters>({
  firstName: '',
  lastName: '',
  city: '',
  company: '',
  phoneNumber: '',
  position: '',
  email: '',
  orderBy: 'DESC',
  sortBy: '',
  page: 1,
  limit: 10,
});

async function getPartnerPractices(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: IAddressBookFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }

  const perPageRes = partnerPractices.value?.pagination?.items_per_page;

  try {
    const {data} = await partnerPracticesService.getPartnerPractices({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    partnerPractices.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function confirmDelete() {
  try {
    await partnerPracticesService.deletePartnerPractice(partnerId.value!);
    partnerId.value = null;
    showModal.value = false;
    await getPartnerPractices();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function getIconClass(key: string) {
  return getSortIconClass(filters.value, key);
}

async function sortBy(key: string) {
  filters.value = {
    ...filters.value,
    sortBy: key,
    orderBy: filters.value.orderBy === 'DESC' || filters.value.sortBy !== key ? 'ASC' : 'DESC',
  };
  await getPartnerPractices();
}

async function getFederalStateDropdown() {
  federalStatesDropdown.value = getEnums.value.federalStates;
}

function deleteModal(id: number) {
  CloseToast();
  partnerId.value = id;
  showModal.value = true;
}

async function getExcelExport() {
  await downloadFile('/address-book/partner-practices/excel-export', undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}

onMounted(async () => {
  CloseToast()
  await Promise.all([
    getPartnerPractices(),
    getFederalStateDropdown(),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('general.contacts')), 1),
              _createVNode(CreateButton, {
                label: _ctx.$t('address_book.create_partner_practices'),
                to: { name: 'addressBookPartnerPracticesForm' }
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('address_book.partner_practices')), 1),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                federalStatesDropdown: federalStatesDropdown.value,
                type: "client",
                onSearch: getPartnerPractices
              }, null, 8, ["filters", "loading", "federalStatesDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getPartnerPractices
              }),
              _createVNode(ExcelExportButton, {
                style: {"margin-right":"15px"},
                label: _ctx.$t('general.excel_export'),
                loading: isExcelLoaded.value,
                onClick: getExcelExport
              }, null, 8, ["label", "loading"]),
              (!partnerPractices.value?.data?.length)
                ? (_openBlock(), _createBlock(EmptyState, {
                    key: 0,
                    icon: "fa-address-book",
                    title: "Keine Kontakte gefunden",
                    subtitle: "Es wurden keine Kontakte gefunden, die Ihren Suchkriterien entsprechen."
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (sortBy('firstName')), ["prevent"]))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.first_name')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('firstName'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (sortBy('lastName')), ["prevent"]))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.last_name')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('lastName'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (sortBy('company')), ["prevent"]))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('general.company_client')), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('company'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortBy('phoneNumber')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.phone_number')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('phoneNumber'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (sortBy('email')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.email')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('email'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('address')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.street')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('address'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (sortBy('zip')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.postal_code')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('zip'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (sortBy('city')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.city')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('city'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (sortBy('federalState')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.federal_state')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('federalState'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (sortBy('position')))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('general.position')) + " ", 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(getIconClass('position'))
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.info')), 1),
                          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('general.actions')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partnerPractices.value?.data, (partner) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: partner.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(partner?.firstName), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.lastName), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.company), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.phoneNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.email), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.address), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.zip), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.city), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.federalStateTranslation), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.position), 1),
                            _createElementVNode("td", null, _toDisplayString(partner?.info ? 'JA' : 'NEIN'), 1),
                            _createElementVNode("td", _hoisted_9, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_unref(router).push({name: 'addressBookPartnerPracticesForm', params: {id: partner?.id} }))
                              }, [...(_cache[11] || (_cache[11] = [
                                _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                              ]))], 8, _hoisted_10),
                              _createElementVNode("button", {
                                class: "btn btn-danger ms-2",
                                onClick: ($event: any) => (deleteModal(partner?.id!))
                              }, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "os-icon os-icon-trash" }, null, -1)
                              ]))], 8, _hoisted_11)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])),
              (partnerPractices.value?.pagination?.total_pages ?? 0 > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 2,
                    totalPages: partnerPractices.value?.pagination?.total_pages,
                    currentPage: partnerPractices.value?.pagination?.current_page,
                    totalItems: partnerPractices.value?.pagination?.total_items,
                    perPage: partnerPractices.value?.pagination?.items_per_page,
                    onPagechanged: getPartnerPractices
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(ModalDelete, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showModal).value = $event)),
        header: _unref(t)('general.delete_item_header'),
        onDelete: confirmDelete
      }, null, 8, ["modelValue", "header"])
    ]),
    _: 1
  }))
}
}

})